const KEY_LAST_CALL_LIST = 'lastCallListId';

export const getLastSelectedCallListId = () => {
  const id = window.localStorage.getItem(KEY_LAST_CALL_LIST);
  return id ? parseInt(id) : null;
};
export const setLastSelectedCallListId = id => window.localStorage.setItem(KEY_LAST_CALL_LIST, id);
